import { History } from "history";
import {
  StudentsWithoutActiveSubscription,
  StudentsWithActiveSubscription,
  ParentsWithoutActiveChildSubscription,
  ParentsWithActiveChildSubscription,
  SubscriptionReportRequest,
} from "../../interfaces/reports";

//#region Get Subscription Report

export const GET_SUBSCRIPTION_REPORT = "GET_SUBSCRIPTION_REPORT";
export const GET_SUBSCRIPTION_REPORT_SUCCESS: any =
  "GET_SUBSCRIPTION_REPORT_SUCCESS";
export const GET_SUBSCRIPTION_REPORT_ERROR: any =
  "GET_SUBSCRIPTION_REPORT_ERROR";
export const RESET_SUBSCRIPTION_REPORT: any =
  "RESET_NO_SUBSCRIPTION_PARENTS_REPORT";

export interface GetSubscriptionReportAction {
  type: typeof GET_SUBSCRIPTION_REPORT;
  payload: { request: SubscriptionReportRequest };
}

export interface GetSubscriptionReportSuccessAction {
  type: typeof GET_SUBSCRIPTION_REPORT_SUCCESS;
  payload:
    | StudentsWithoutActiveSubscription[]
    | StudentsWithActiveSubscription[]
    | ParentsWithoutActiveChildSubscription[]
    | ParentsWithActiveChildSubscription[];
}

export interface GetSubscriptionReportErrorAction {
  type: typeof GET_SUBSCRIPTION_REPORT_ERROR;
  payload: any;
}

export interface ResetSubscriptionReportAction {
  type: typeof RESET_SUBSCRIPTION_REPORT;
  payload: {};
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetSubscriptionReportAction
  | GetSubscriptionReportSuccessAction
  | GetSubscriptionReportSuccessAction
  | ResetSubscriptionReportAction;
